export default __webpack_public_path__ + "static/media/motevafa.e3d3bedb.jpg";